module.exports = __webpack_public_path__ + "static/media/8S.4ff481d5.svg";